import * as React from 'react';
import { HardwareAction, HardwareType, LessonStep, UserCourseDTO, UserLessonDTO } from "../../common/TrainingTypes";
import Markdown from 'react-markdown';
import { PRSMasterComponent } from "../../components/panel-ui/PRSMaster";
import { ODMPanelComponent } from '../../components/panel-ui/ODM';
import { TDMExpander } from '../../components/panel-ui/TDM';
import { IO8Expander } from '../../components/panel-ui/IO8';

export function HardwareLessonComponent(props: { course: UserCourseDTO, lesson: UserLessonDTO, step: LessonStep, stepDone: (state: boolean) => void }) {

    const onAction = (action: HardwareAction, value: string) => {
        if (action === props.step.hardwareAction) {
            if (props.step.hardwareAction && value !== props.step.hardwareValue)
                return;
            props.stepDone(true);
        }
        console.log('Action ', HardwareAction[action].toString(), value);
    }

	return (
		<div className="card">
			<div className="card-header">
				<h5 className="card-title mb-0">{props.lesson.name} &bull; {props.step.name}</h5>
			</div>
			<div className="card-body">
				<div className="row">
                    <div className="col-4">
                        {props.step.videoURL ?
                            <div className="video-responsive">
                                <iframe className="w-100" style={{ aspectRatio: "16/9" }}
                                    src={props.step.videoURL + "?autoplay=1"}
                                    frameBorder="0"
                                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                                    allowFullScreen
                                    title="Embedded youtube"
                                />
                            </div> : <></>}
                        <Markdown>{props.step.content.replaceAll('\n\n', '  \n&nbsp;  \n').replaceAll('\n', '  \n')}</Markdown>
                    </div>
                    <div className="col-8">
                        {props.step.hardwareType === HardwareType.PRSMaster ? <PRSMasterComponent onAction={onAction}></PRSMasterComponent> :
                        props.step.hardwareType === HardwareType.PRS8DR ? <>
                            <PRSMasterComponent onAction={onAction}></PRSMasterComponent>
                            <div className="mt-3">
                                <TDMExpander />
                                <span style={{ marginLeft: '94px' }}>
                                    <TDMExpander />
                                </span>
                            </div>
                            <div className="mt-3">
                                <TDMExpander />
                                <span style={{ marginLeft: '94px' }}>
                                    <TDMExpander />
                                </span>
                            </div>
                        </>:
                        props.step.hardwareType === HardwareType.PRSElevator ? <>
                                <PRSMasterComponent onAction={onAction}></PRSMasterComponent>
                                <div className="mt-3">
                                        <TDMExpander address={9} />
                                        <span style={{ marginLeft: '94px' }}>
                                            <IO8Expander address={2} />
                                    </span>
                                </div>
                                <div className="mt-3">
                                        <IO8Expander address={1} />
                                    <span style={{ marginLeft: '94px' }}>
                                            <IO8Expander address={3} />
                                    </span>
                                </div>
                        </>:
                        props.step.hardwareType === HardwareType.PRSIO ? <>
                            <PRSMasterComponent onAction={onAction}></PRSMasterComponent>
                        </>:
                        props.step.hardwareType === HardwareType.POE ? <ODMPanelComponent></ODMPanelComponent> : <></>}				
                    </div>
				</div>
			</div>
		</div>
	)
}